import { Injectable } from '@angular/core';
import { DTypeStatus, NextLocator, Partaker } from '@grupo-constant/next-dtype/types';
import { BehaviorSubject, map, of } from 'rxjs';
import { USER_URI } from '../projects/projects.service';
import { UserNodePrivileges, UserProfile } from '../projects/projects.types';
import { NextOu, OU_URI, RetrieveNextOuReply, RetrieveNextPermissionsReply, UpdateNextOuReply } from './ou.types';
import { DTypeService } from '../../../core/dtype/dtype.service';
import { HttpService } from '../../../core/http/http.service';
import { NextMethodsEnum } from '../../../core/enums/next-methods.enum';

@Injectable({
    providedIn: 'root'
})
export class OUService {

    ou: NextOu;
    role = new BehaviorSubject<UserNodePrivileges>(undefined);

    constructor(
        private dtypeService: DTypeService,
        private http: HttpService
    ) { }

    getOu() {
        if (this.ou) {
            return of(this.ou);
        }
        return this.retrieveOu();
    }

    getOuForm(ou: NextOu) {
        return this.dtypeService.getDtypeFormByUri({ uri: OU_URI, status: DTypeStatus.DESIGN, bindableOptions: true }, ou, { readonly: false, isUpdate: true});
    }

    updateOu(ou: NextOu) {
        return this.http.post<UpdateNextOuReply>(NextMethodsEnum.updateNextOu, { nextOu: ou });
    }

    retrieveNextPermissions(locator?: NextLocator) {
        return this.http.post<RetrieveNextPermissionsReply>(NextMethodsEnum.retrieveNextPermissions, { locator });
    }

    private retrieveOu() {
        return this.http.post<RetrieveNextOuReply>(NextMethodsEnum.retrieveNextOu, { ou: '01' }).pipe(
            map((reply) => {
                this.createProfileFields(reply.nextOu, reply.partaker);
                return reply.nextOu;
            })
        );
    }

    private createProfileFields(ou: NextOu, partaker: Partaker) {
        for (const key of Object.keys(ou).filter(k => k.startsWith('userprofile'))) {
            ou[this.getProfileNameByUri(key)] = ou[key].map((u) => {
                if (typeof u === 'string') {
                    const user: UserProfile = { ...partaker?.[USER_URI]?.[u] };
                    if (user) {
                        user.userId = u;
                    }
                    return user;
                } else {
                    const user: UserProfile = { ...partaker?.[USER_URI]?.[u.userId], ...u };
                    if (user && user.grantor && user.grantor !== 'system') {
                        user.grantorName = partaker[USER_URI][user.grantor].displayName;
                    }
                    return user;
                }
            });
        }
    }

    private getProfileNameByUri(uri: string) {
        if (uri === 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileSuperuser') {
            return 'superuser';
        } else if (uri === 'userprofile://com.cloudcodice.thirdparty.grupoconstant.privileges.profile.UserProfileDeveloper') {
            return 'developer';
        }
    }

}
